"use strict";

exports.__esModule = true;
exports.FilterDeviceListController = FilterDeviceListController;
var _react = _interopRequireDefault(require("react"));
var _URLFilter = require("../../Core/URLFilter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function FilterDeviceListController(_ref) {
  var children = _ref.children,
    _ref$property = _ref.property,
    property = _ref$property === void 0 ? "devices" : _ref$property;
  var _React$useContext = _react["default"].useContext(_URLFilter.URLFilterContext),
    filters = _React$useContext.filters,
    setFilter = _React$useContext.setFilter;
  var state = {
    selectedDevices: filters[property] || [],
    onDeviceSelect: function onDeviceSelect(deviceUuidList) {
      setFilter(property, deviceUuidList);
    }
  };
  return children(state);
}